import { configValue } from 'config/appConfigUtils';

import type { AlgoliaSearchMultiQuery } from './algoliaSearchMulti';

export function temporarilyExcludeVMFromSearch({
  query,
  allowIncludeVMResults = false,
}: {
  query: AlgoliaSearchMultiQuery;
  allowIncludeVMResults: boolean;
}): string {
  // TODO: We should fix the type definition in configValue
  // to avoid unnecessary Boolean casting
  const isFeatureEnabled = Boolean(
    configValue('idealist', 'vm', 'listingsVisible'),
  );

  // if the feature is enabled in config, return the query
  if (isFeatureEnabled) return query.options?.filters || '';
  // this is normally staff/embed widget
  if (allowIncludeVMResults) return query.options?.filters || '';

  // otherwise return query by appending the filters and keeping the correct filter syntax
  if (query.options.filters)
    return `${query.options.filters} AND NOT fromVm:true`;

  return 'NOT fromVm:true';
}
